// src/pages/Admin/Messages.js
import React, { useState, useEffect, useContext } from 'react';
import { apiFetch } from '../../utils/apiClient';
import { BASE_URL } from '../../utils/config';
import { UserContext } from '../../context/UserContext';
import { NotificationContext } from '../../context/NotificationContext';
import './Messages.css';

const Messages = () => {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const { user } = useContext(UserContext);
  const { addNotification } = useContext(NotificationContext);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await apiFetch(`${BASE_URL}/api/general/messages`, {}, user.token);
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({ message: 'Failed to fetch messages.' }));
          throw new Error(errorData.message);
        }
        const data = await response.json();
        if (Array.isArray(data)) {
          // Now check if the parsed data is an array
          setMessages(data);
        } else {
          console.error('API did not return an array for messages:', data);
          addNotification('Received invalid data from server.', 'error');
          setMessages([]); // Ensure it's always an array to prevent crashes
        }
      } catch (error) {
        addNotification(error.message || 'Failed to fetch messages.', 'error');
        setMessages([]); // Also set to empty array on error
      } finally {
        setIsLoading(false);
      }
    };

    fetchMessages();
  }, [user.token, addNotification]);

  const handleViewMessage = (message) => {
    setSelectedMessage(message);
  };

  const handleCloseModal = () => {
    setSelectedMessage(null);
  };

  if (isLoading) {
    return <div className="messages-container">Loading messages...</div>;
  }

  return (
    <div className="messages-container">
      <h2>Contact Us Submissions</h2>
      {messages.length === 0 ? (
        <p>No messages found.</p>
      ) : (
        <table className="messages-table">
          <thead>
            <tr>
              <th>Ticket ID</th>
              <th>Date</th>
              <th>Name</th>
              <th>Email</th>
              <th>Subject</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {messages.map((msg) => (
              <tr key={msg._id}>
                <td>{msg.ticketId}</td>
                <td>
                  {new Date(msg.createdOn).toLocaleString(undefined, {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </td>
                <td>{msg.name}</td>
                <td>{msg.email}</td>
                <td>{msg.subject}</td>
                <td>
                  <button onClick={() => handleViewMessage(msg)} className="view-btn">
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {selectedMessage && (
        <div className="modal-backdrop" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Message from {selectedMessage.name}</h3>
            <p>
              <strong>Ticket ID:</strong> {selectedMessage.ticketId}
            </p>
            <p>
              <strong>Email:</strong> {selectedMessage.email}
            </p>
            <p>
              <strong>Subject:</strong> {selectedMessage.subject}
            </p>
            <p>
              <strong>Message:</strong>
            </p>
            <pre className="message-body">{selectedMessage.message}</pre>
            <button onClick={handleCloseModal} className="message-modal-close-btn">
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Messages;
